/*
 * ******************************************************************
 * Copyright (c) 2022-2025 Broadcom. All Rights Reserved.
 * Broadcom Confidential. The term "Broadcom" refers to Broadcom Inc.
 * and/or its subsidiaries.
 * ******************************************************************
 */
import { APP_ROUTES_UTIL } from "@app/app-routing.util";

export class VMCFS_CONSOLE {
    public static readonly EMPTY = "";
    public static readonly ROOT = "storage";
    public static readonly ROOT_ABSOLUTE = APP_ROUTES_UTIL.absolutePath(this.EMPTY, this.ROOT);
    public static readonly REGIONS = "regions";
    public static readonly REGIONS_SETUP = this.REGIONS + APP_ROUTES_UTIL.SLASH + "activate-region";
    public static readonly REGIONS_SETUP_ABSOLUTE = this.ROOT_ABSOLUTE + this.REGIONS_SETUP;
    public static readonly REGIONS_IMPORT = this.REGIONS + APP_ROUTES_UTIL.SLASH + "import-region";
    public static readonly REGIONS_IMPORT_ABSOLUTE = this.ROOT_ABSOLUTE + this.REGIONS_IMPORT;
    public static readonly REGIONS_ABSOLUTE = this.ROOT_ABSOLUTE + this.REGIONS;
    public static readonly SUBSCRIPTIONS = "subscriptions";
    public static readonly SUBSCRIPTIONS_SETUP = this.SUBSCRIPTIONS + APP_ROUTES_UTIL.SLASH + "create-subscription";
    public static readonly SUBSCRIPTIONS_SETUP_ABSOLUTE = this.ROOT_ABSOLUTE + this.SUBSCRIPTIONS_SETUP;
    public static readonly SUBSCRIPTIONS_ABSOLUTE = this.ROOT_ABSOLUTE + this.SUBSCRIPTIONS;
    public static readonly SUBSCRIPTION_REPORTS = "subscription-reports";
    public static readonly SUBSCRIPTION_REPORTS_ABSOLUTE = this.ROOT_ABSOLUTE + this.SUBSCRIPTION_REPORTS;
    public static readonly ACTIVITY_LOG = "activitylog";
    public static readonly ACTIVITY_LOG_ABSOLUTE = this.ROOT_ABSOLUTE + this.ACTIVITY_LOG;
    public static readonly SETTINGS = "settings";
    public static readonly SETTINGS_ABSOLUTE = this.ROOT_ABSOLUTE + this.SETTINGS;
    public static readonly TASKS = "tasks";
    public static readonly TASKS_RELATIVE = this.ACTIVITY_LOG + APP_ROUTES_UTIL.SLASH + this.TASKS;
    public static readonly TASKS_ABSOLUTE = this.ROOT_ABSOLUTE + this.TASKS_RELATIVE;
    public static readonly EVENTS = "events";
    public static readonly EVENTS_RELATIVE = this.ACTIVITY_LOG + APP_ROUTES_UTIL.SLASH + this.EVENTS;
    public static readonly EVENTS_ABSOLUTE = this.ROOT_ABSOLUTE + this.EVENTS_RELATIVE;
    public static readonly VMCFS_SETTINGS = "vmcfs";
    public static readonly VMCFS_SETTINGS_RELATIVE = this.SETTINGS + APP_ROUTES_UTIL.SLASH + this.VMCFS_SETTINGS;
    public static readonly VMCFS_SETTINGS_ABSOLUTE = this.ROOT_ABSOLUTE + this.VMCFS_SETTINGS_RELATIVE;
    public static readonly ERROR_403 = "error";
    public static readonly CAPABILITIES_ERROR = "error-props";
    public static readonly CAPABILITIES_ERROR_ABSOLUTE = this.ROOT_ABSOLUTE + this.CAPABILITIES_ERROR;
    public static readonly ACCESS_REQUEST_SUCCESS = "success";
    public static readonly ACCESS_REQUEST_SUCCESS_ABSOLUTE = this.ROOT_ABSOLUTE + this.ACCESS_REQUEST_SUCCESS;
}
